<div class="agpr-vi-reports">
    <div class="agpr-vi-reports-toolbar">
        <div class="agpr-vi-reports-toolbar-date">
            <agpr-date-query-popup
                class="agpr-vi-reports-dateQueryPopup"
                [id]="'vi_reports_dateQueryPopup'"
                [header]="'Monitoring.dateQueryDialog.header'"
                [options]="dateFilterOptions"
                [dateTypeOptions]="dateTypeFilterOptions"
                [useDateSearchRangeSelection]="false"
                [searchRange]="searchRange"
                [(ngModel)]="dateRange"
            ></agpr-date-query-popup>
            <!-- ignore date change for now (ngModelChange)="dateRangeChanged($event)" -->
        </div>
        <div class="agpr-vi-reports-toolbar-filter">
            <!-- We don't need filters in V1 -->
            <!-- <div class="agpr-vi-reports-filterDropdown">
                <agpr-filter-dropdown
                    [id]="'vi_reports_filterDropdown'"
                    [showQuickFilter]="true"
                    quickFilterPlaceholder="Monitoring.filtersLocalization.keywords.quickPlaceholder"
                    ariaLabel="Monitoring.filtersLocalization.ariaLabel"
                    [ariaDescribedBy]="'resultsFilters.chips'"
                ></agpr-filter-dropdown>
            </div>
            <div class="agpr-vi-reports-filterChips">
                <agpr-filter-chips
                    #filterChipsComponent
                    [id]="'vi_reports_filterChips'"
                ></agpr-filter-chips>
                @if (filterChipsComponent.chips.length > 1) {
                    <agpr-button
                        class="agpr-vi-reports-filterClearButton"
                        [id]="'vi_reports_filterClearButton'"
                        [style]="buttonTypes.icon"
                        icon="fa-kit-duotone fa-agpr-remove-all"
                        tooltip="Monitoring.result.filters.clear"
                        tooltipPosition="top"
                        (click)="clearFilters(true)"
                    ></agpr-button>
                }
                <agpr-button
                    [ngClass]="{
                        'agpr-vi-reports-filterLockIcon--lock': filtersLocked,
                        'agpr-vi-reports-filterLockIcon--unlock': !filtersLocked
                    }"
                    [id]="'filter.lock'"
                    [style]="buttonTypes.icon"
                    [icon]="filtersLocked ? 'fa-regular fa-duotone fa-lock' : 'fa-regular fa-duotone fa-unlock'"
                    [tooltip]="filtersLocked ? 'Monitoring.result.filters.unlock' : 'Monitoring.result.filters.lock'"
                    tooltipPosition="top"
                    (click)="toggleFilterLock()"
                ></agpr-button>
            </div> -->
        </div>
    </div>

    <agpr-scroll-panel>
        <div class="agpr-vi-reports-dashboard">
            <agpr-vi-summary
                [loading]="refreshing$ | async"
                (reportSeriesReady)="fulfillSeries($event)"
                (reportSeriesChange)="updateSeries($event)"
            ></agpr-vi-summary>
        </div>
    </agpr-scroll-panel>
</div>
